export default "__VITE_PUBLIC_ASSET__47af8d8d__"